import { render, staticRenderFns } from "./MaterialLabelPrintTemplateEdit.vue?vue&type=template&id=64494149&scoped=true&"
import script from "./MaterialLabelPrintTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialLabelPrintTemplateEdit.vue?vue&type=style&index=0&id=64494149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64494149",
  null
  
)

export default component.exports